export default [
    {
        path: '/asset/asset-maintenance',
        name: 'asset-maintenance',
        props: true,
        component: () => import('@/views/asset/maintenance/index.vue'),
        meta: {
            pageTitle: 'Asset Maintenance',
            breadcrumb: [
                {
                text: 'Asset Maintenance',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-maintenance/add',
        name: 'create-asset-maintenance',
        component: () => import('@/views/asset/maintenance/create.vue'),
        meta: {
            pageTitle: 'Create Asset Maintenance',
            breadcrumb: [
                {
                text: 'Asset Maintenance',
                to: { name: 'asset-maintenance' },
                },
                {
                text: 'Create Asset Maintenance',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-maintenance/:id',
        name: 'detail-asset-maintenance',
        props: true,
        component: () => import('@/views/asset/maintenance/detail.vue'),
        meta: {
            pageTitle: 'Detail Asset Maintenance',
            breadcrumb: [
                {
                text: 'Asset Maintenance',
                to: { name: 'asset-maintenance' },
                },
                {
                text: 'Detail Asset Maintenance',
                active: true,
                },
            ],
        },
    },
]